import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getEarningRules,
  updateEarningRule,
} from "../../store/rewardWallet/rewardWallet.action";

const sourceDisplay = (src) => {
  const map = {
    signup: "Signup Bonus",
    ad_view: "Rewarded Ad View",
    video_watch: "Video Watch (Reel)",
    product_share: "Product Share",
    first_purchase_bonus: "First Purchase (Buyer)",
    referral_first_purchase: "Referral — First Purchase",
  };
  return map[src] || src;
};

const blankForm = {
  source: "",
  coins: "",
  dailyActionCap: "",
  dailyCap: "",
  lifetimeCap: "",
  cooldownSeconds: "",
  expiryDays: "",
  enabled: true,
  notes: "",
};

const EarningRules = () => {
  const dispatch = useDispatch();
  const { rules } = useSelector((s) => s.rewardWallet);
  const admin = useSelector((s) => s.admin?.admin) || {};

  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(blankForm);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    dispatch(getEarningRules());
  }, [dispatch]);

  const openEdit = (r) => {
    setEditing(r);
    setForm({
      source: r.source,
      coins: r.coins ?? "",
      dailyActionCap: r.dailyActionCap ?? "",
      dailyCap: r.dailyCap ?? "",
      lifetimeCap: r.lifetimeCap ?? "",
      cooldownSeconds: r.cooldownSeconds ?? "",
      expiryDays: r.expiryDays ?? "",
      enabled: !!r.enabled,
      notes: r.notes || "",
    });
  };

  const closeEdit = () => {
    setEditing(null);
    setForm(blankForm);
  };

  const submit = (e) => {
    e.preventDefault();
    if (saving) return;

    const toNum = (v) => (v === "" || v === null ? null : Number(v));
    const payload = { source: form.source };

    const fields = [
      "coins",
      "dailyActionCap",
      "dailyCap",
      "lifetimeCap",
      "cooldownSeconds",
      "expiryDays",
    ];
    for (const f of fields) {
      const n = toNum(form[f]);
      if (n === null) continue;
      if (!Number.isInteger(n) || n < 0) {
        alert(`${f} must be a non-negative integer`);
        return;
      }
      payload[f] = n;
    }
    if (payload.coins !== undefined && payload.coins === 0) {
      alert("coins must be > 0");
      return;
    }
    payload.enabled = !!form.enabled;
    payload.notes = (form.notes || "").trim();

    setSaving(true);
    dispatch(
      updateEarningRule(payload, admin?._id, (ok) => {
        setSaving(false);
        if (ok) closeEdit();
      })
    );
  };

  return (
    <div className="mainSellerTable">
      <div className="sellerTable">
        <div className="col-12 headname">Coin Earning Rules</div>

        <div className="row mx-2 mb-3">
          <div className="col-12">
            <div
              className="p-3"
              style={{ background: "#EBF5FF", borderRadius: 8, color: "#1F2937" }}
            >
              <strong>Rate:</strong> 1000 coins = $1.00 (1 coin = $0.001). Tune
              any rule by clicking <strong>Edit</strong> — changes apply
              immediately (no redeploy). Every edit writes an audit entry to the
              coin ledger.
            </div>
          </div>
        </div>

        <div className="sellerMain">
          <div className="tableMain">
            <div className="primeMain">
              <table width="100%" className="primeTable text-center">
                <thead
                  className="sticky-top"
                  style={{ top: "-1px", zIndex: "1" }}
                >
                  <tr>
                    <th className="fw-bold py-3">Source</th>
                    <th className="fw-bold py-3">Coins / Action</th>
                    <th className="fw-bold py-3">USD Value</th>
                    <th className="fw-bold py-3">Daily Action Cap</th>
                    <th className="fw-bold py-3">Daily Coin Cap</th>
                    <th className="fw-bold py-3">Lifetime Cap</th>
                    <th className="fw-bold py-3">Cooldown</th>
                    <th className="fw-bold py-3">Expiry</th>
                    <th className="fw-bold py-3">Enabled</th>
                    <th className="fw-bold py-3">Notes</th>
                    <th className="fw-bold py-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rules?.length > 0 ? (
                    rules.map((r) => (
                      <tr key={r._id}>
                        <td className="text-white py-3 text-start ps-3">
                          <div className="fw-medium">
                            {sourceDisplay(r.source)}
                          </div>
                          <small
                            style={{ color: "#9CA3AF", fontFamily: "monospace" }}
                          >
                            {r.source}
                          </small>
                        </td>
                        <td className="text-white py-3 fw-bold">{r.coins}</td>
                        <td className="text-white py-3">
                          <small>${(r.coins / 1000).toFixed(3)}</small>
                        </td>
                        <td className="text-white py-3">
                          {r.dailyActionCap || "—"}
                        </td>
                        <td className="text-white py-3">
                          {r.dailyCap || "—"}
                        </td>
                        <td className="text-white py-3">
                          {r.lifetimeCap || "—"}
                        </td>
                        <td className="text-white py-3">
                          {r.cooldownSeconds ? `${r.cooldownSeconds}s` : "—"}
                        </td>
                        <td className="text-white py-3">
                          {r.expiryDays ? `${r.expiryDays}d` : "—"}
                        </td>
                        <td className="py-3">
                          <span
                            className="px-3 py-1"
                            style={{
                              backgroundColor: r.enabled ? "#D1FAE5" : "#FEE2E2",
                              color: r.enabled ? "#10B981" : "#EF4444",
                              borderRadius: 20,
                              fontSize: 12,
                              fontWeight: 500,
                            }}
                          >
                            {r.enabled ? "Yes" : "No"}
                          </span>
                        </td>
                        <td
                          className="text-white py-3 text-start"
                          style={{ maxWidth: 300 }}
                        >
                          <small style={{ color: "#9CA3AF" }}>
                            {r.notes || "—"}
                          </small>
                        </td>
                        <td className="py-3">
                          <button
                            type="button"
                            className="btn btn-sm"
                            onClick={() => openEdit(r)}
                            style={{
                              backgroundColor: "#F0C420",
                              color: "#1F2937",
                              fontWeight: 600,
                              borderRadius: 6,
                              padding: "4px 14px",
                            }}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center text-white py-5">
                        No rules found. Run the seed script on the server.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {editing && (
        <div
          onClick={closeEdit}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            zIndex: 1050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <form
            onClick={(e) => e.stopPropagation()}
            onSubmit={submit}
            style={{
              background: "#FFFFFF",
              borderRadius: 10,
              padding: 24,
              width: "min(640px, 94vw)",
              maxHeight: "90vh",
              overflowY: "auto",
              color: "#1F2937",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
              border: "1px solid #E5E7EB",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="mb-0" style={{ color: "#111827" }}>
                  Edit Earning Rule
                </h5>
                <small style={{ color: "#6B7280" }}>
                  {sourceDisplay(editing.source)}{" "}
                  <code style={{ color: "#6B7280" }}>({editing.source})</code>
                </small>
              </div>
              <button
                type="button"
                onClick={closeEdit}
                className="btn btn-sm"
                style={{
                  border: "1px solid #D1D5DB",
                  color: "#374151",
                  background: "transparent",
                }}
              >
                ×
              </button>
            </div>

            <div className="row g-3">
              <div className="col-12 col-md-6">
                <label className="form-label" style={{ color: "#374151", fontWeight: 500 }}>
                  Coins / Action <span style={{ color: "#EF4444" }}>*</span>
                </label>
                <input
                  type="number"
                  min="1"
                  className="form-control"
                  value={form.coins}
                  onChange={(e) =>
                    setForm({ ...form, coins: e.target.value })
                  }
                />
                <small style={{ color: "#6B7280" }}>
                  ≈ ${((Number(form.coins) || 0) / 1000).toFixed(3)}
                </small>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label" style={{ color: "#374151", fontWeight: 500 }}>Daily Action Cap</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={form.dailyActionCap}
                  onChange={(e) =>
                    setForm({ ...form, dailyActionCap: e.target.value })
                  }
                  placeholder="0 = unlimited"
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label" style={{ color: "#374151", fontWeight: 500 }}>Daily Coin Cap</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={form.dailyCap}
                  onChange={(e) =>
                    setForm({ ...form, dailyCap: e.target.value })
                  }
                  placeholder="0 = unlimited"
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label" style={{ color: "#374151", fontWeight: 500 }}>Lifetime Cap</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={form.lifetimeCap}
                  onChange={(e) =>
                    setForm({ ...form, lifetimeCap: e.target.value })
                  }
                  placeholder="0 = unlimited"
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label" style={{ color: "#374151", fontWeight: 500 }}>Cooldown (seconds)</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={form.cooldownSeconds}
                  onChange={(e) =>
                    setForm({ ...form, cooldownSeconds: e.target.value })
                  }
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label" style={{ color: "#374151", fontWeight: 500 }}>Expiry (days)</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  value={form.expiryDays}
                  onChange={(e) =>
                    setForm({ ...form, expiryDays: e.target.value })
                  }
                  placeholder="0 = never"
                />
              </div>

              <div className="col-12">
                <label className="form-label" style={{ color: "#374151", fontWeight: 500 }}>Notes</label>
                <textarea
                  className="form-control"
                  rows={2}
                  value={form.notes}
                  onChange={(e) =>
                    setForm({ ...form, notes: e.target.value })
                  }
                />
              </div>

              <div className="col-12">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="ruleEnabledSwitch"
                    checked={!!form.enabled}
                    onChange={(e) =>
                      setForm({ ...form, enabled: e.target.checked })
                    }
                  />
                  <label
                    htmlFor="ruleEnabledSwitch"
                    className="form-check-label"
                    style={{ color: "#374151", fontWeight: 500 }}
                  >
                    Enabled
                  </label>
                </div>
              </div>
            </div>

            <div
              className="d-flex justify-content-end gap-2 mt-4 pt-3"
              style={{ borderTop: "1px solid #E5E7EB" }}
            >
              <button
                type="button"
                onClick={closeEdit}
                className="btn"
                disabled={saving}
                style={{
                  border: "1px solid #D1D5DB",
                  color: "#374151",
                  background: "#FFFFFF",
                  fontWeight: 500,
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn"
                disabled={saving}
                style={{
                  backgroundColor: "#F0C420",
                  color: "#1F2937",
                  fontWeight: 600,
                }}
              >
                {saving ? "Saving…" : "Save Rule"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default connect(null, { getEarningRules, updateEarningRule })(
  EarningRules
);
